import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs';
import { AppSettings } from 'src/config/config';
import { commonFunctionService } from '../utils/commonFunctions';
import { apiConstants } from '../constant/apiConstant';

@Injectable({
  providedIn: 'root'
})
export class FeesOverdueReportService {

  private URL_V3 = AppSettings.API_ENDPOINT_V3;
  headers: HttpHeaders;
  private language = "en";

  constructor(private http: HttpClient, private commonFunction: commonFunctionService) { }

  checkSortByRollNumber(params: any) {
    const headers = this.commonFunction.appendHeader();
    return this.http.get(this.URL_V3 + apiConstants.checkSortByRollNumber,
      {
        headers: headers,
        params: params
      }
    ).pipe(map((res) => res));
  }

  getWingListData() {
    const headers = this.commonFunction.appendHeader();
    return this.http.get(this.URL_V3 + apiConstants.getWingData, {
      headers: headers,
      params: { lang: this.language }
    }).pipe(map((res) => res));
  }


  getClassListData(body) {
    const headers = this.commonFunction.appendHeader();
    return this.http.post(this.URL_V3 + apiConstants.getClassStandardListInfo, body, {
      headers: headers,
    }).pipe(map((res) => res));
  }

  getClassSectionListData(body) {
    const headers = this.commonFunction.appendHeader();
    return this.http.post(this.URL_V3 + apiConstants.getClassSectionDataInfo, body, {
      headers: headers,
    }).pipe(map((res) => res));
  }

  getStudentListData(paramsBody) {
    const headers = this.commonFunction.appendHeader();
    return this.http.get(this.URL_V3 + apiConstants.getStudentListAPIEndPoint, {
      headers: headers,
      params: paramsBody
    }).pipe(map((res) => res));
  }

  getFeeListData(paramsBody) {
    const headers = this.commonFunction.appendHeader();
    return this.http.get(this.URL_V3 + apiConstants.getFeeListData, {
      headers: headers,
      params: paramsBody
    }).pipe(map((res) => res));
  }

  getFeesOverdueReportStats(body) {
    const headers = this.commonFunction.appendHeader();
    return this.http.post(this.URL_V3 + apiConstants.getFeesOverdueReportStats, body, {
      headers: headers,
    }).pipe(map((res) => res));
  }

  getFeesOverdueClassData(body) {
    const headers = this.commonFunction.appendHeader();
    return this.http.post(this.URL_V3 + apiConstants.getFeesOverdueClassData, body, {
      headers: headers,
    }).pipe(map((res) => res));
  }

  getStudentWiseFeeDetails(body) {
    const headers = this.commonFunction.appendHeader();
    return this.http.post(this.URL_V3 + apiConstants.getStudentWiseFeeDetails, body, {
      headers: headers,
    }).pipe(map((res) => res));
  }

    getExportColumnsForFeesOverdueReport(paramsBody) {
    const headers = this.commonFunction.appendHeader();
    return this.http.get(this.URL_V3 + apiConstants.getColumnListForExportReport, {
      headers: headers,
      params: paramsBody
    }).pipe(map((res) => res));
  }

  exportFeesOverdueReport(body) {
    const headers = this.commonFunction.appendHeader();
    return this.http.post(this.URL_V3 + `${apiConstants.exportFeesOverdueReport}`,body,{ headers , responseType: 'blob' as 'json' }).pipe(map(res => res));
  }

}
